import React, { useRef, useLayoutEffect } from 'react';
import { connect } from 'react-redux';
import clsx from 'clsx';

// components
import WithPropTestingData from 'src/universal/components/WithPropTestingData';
import LazyLoad from 'src/universal/components/DTM/LazyScrollMetricTracker';
import { AccordionStackedContent } from '@americanexpress/aqx-components';
import { SectionTitle } from 'page_modules/business-pdp/components/SectionTitle';
import { ListWithDrawer } from '@americanexpress/aqx-components';

// selectors
import {
  getAccordionData,
  getMobileAccordionData,
  getAccordionImpressionDtm,
  getOverriddenLabels
} from 'page_modules/business-pdp/redux';

// utils
import { isBrowser } from 'acq-utils/lib/misc';
import useIsMobile from 'src/universal/hooks/useIsMobile';

// vars/enums/etc
import { Color } from '@americanexpress/aqx-components';
import { DATA_TYPES } from 'src/universal/redux/propTesting';

import styles from './__styles__/benefitsAccordion.scss?modules';

const BenefitsAccordion = React.memo(function BenefitsAccordion({
  accordionData,
  mobileAccordionData,
  overridenLabels,
  impressionTrackingData
}) {
  const isMobilePreExisting = useRef(isBrowser() && window.innerWidth <= 767);
  const transitionedToWiderFlag = useRef(false);
  const isMobile = useIsMobile();

  if (isMobilePreExisting.current !== isMobile) {
    isMobilePreExisting.current = isMobile;
    if (isMobile === false) {
      transitionedToWiderFlag.current = true;
    } else {
      transitionedToWiderFlag.current = false;
    }
  }

  useLayoutEffect(
    () => {
      if (transitionedToWiderFlag.current) {
        // next block is to prevent browser from being locked up and becoming unscrollable.
        const backButton = document.querySelector(
          `.${styles.benefitsMobile} ._backButton_yk1rh_33`
        );
        if (backButton && typeof backButton.click === 'function') {
          backButton.click();
        }
      }
    },
    [transitionedToWiderFlag.current]
  );

  const customization = {
    label: {
      paddingLeft: 15,
      color: Color.DeepBlue
    },
    titleHtmlTag: 'span'
  };

  return (
    <article
      className={clsx(
        styles.benefitsAccordion,
        {
          [styles.transitionedToWiderMode]: transitionedToWiderFlag.current
        },
        'accordionEventWrap'
      )}
      data-qe-id="benefits-section"
    >
      <SectionTitle text={overridenLabels.allBenefitsTitle} />
      <LazyLoad scrollDtm={impressionTrackingData} />
      <div className={styles.benefitsDesktop}>
        <AccordionStackedContent
          qeId="benefits-desktop"
          data={accordionData}
          customization={customization}
          $expandItemByIndex={0}
          $openMultiple
          buttonWrapper="h3"
        />
      </div>
      <div className={styles.benefitsMobile}>
        <ListWithDrawer qeId="benefits-mobile" data={mobileAccordionData} />
      </div>
    </article>
  );
});

const mapStateToProps = state => ({
  accordionData: getAccordionData(state),
  mobileAccordionData: getMobileAccordionData(state),
  overridenLabels: getOverriddenLabels(state),
  impressionTrackingData: getAccordionImpressionDtm(state)
});

const PropTestedBenefitsAccordion = WithPropTestingData(
  BenefitsAccordion,
  'BenefitsAccordion',
  DATA_TYPES.cardData
);

export default connect(mapStateToProps)(PropTestedBenefitsAccordion);
